module.exports = __webpack_public_path__ + "img/orange_multiwave.24d43e94.svg";